<script setup>
import liveDetail from "@/components/main/liveVideo/liveDetail.vue";
import {computed, onMounted, ref, watch} from "vue";
import {useLanguageStore, useLoadingStore} from "@/pinia";
const languageStore = useLanguageStore();
const title = computed(() => languageStore.get('liveBroadcastManagement'))
const selectedTab = ref('tab2');
const dataType =  ref(null);
const showModal = ref(false);
const lives = ref([]);
const livesTest =  ref([{
  liveTitle : null,
  liveDescription : null,
  liveStartDt : null,
  privateStatus : null,
  isLive : null
}])
const emits = defineEmits([
    'set_title'
])
const set_selectedTab = (v)=>{
  selectedTab.value = v
}
const openModal=() =>{
    showModal.value = true;
 }
onMounted(()=>{
  emits('set_title', title.value)
})
watch(title, (v) => emits('set_title', v))

</script>
<template>
<div class="contentArea">
    <div class="titleWrapper">
      <div class="tabContent">
        <div class="tabs">
          <div class="tab" :class=" { active : selectedTab === 'tab2'}" @click="selectedTab = 'tab2'">{{languageStore.get('upcoming')}}</div>
          <div class="tab" :class="{ active : selectedTab === 'tab1'}" @click="selectedTab = 'tab1'">{{languageStore.get('inProgress')}}</div>
          <div class="tab" :class=" { active : selectedTab === 'tab3'}" @click="selectedTab = 'tab3'">{{languageStore.get('finished')}}</div>
        </div>

        <div v-if="selectedTab === 'tab1'" class="contentWrapper">
            <live-detail
                @set_selectedTab="set_selectedTab"
                :isLive="'now'"
            ></live-detail>
        </div>

        <div v-else-if="selectedTab === 'tab2'" class="contentWrapper">
          <live-detail
              :isLive="'future'"
          ></live-detail>
        </div>

        <div v-else-if="selectedTab === 'tab3'" class="contentWrapper">
          <live-detail
              :isLive="'past'"
          ></live-detail>
        </div>
      </div>
    </div>
</div>

</template>

<style scoped>

.contentArea {
  border-radius: 10px;
  width: 80vw;
  height: 80vh;
  background-color: white;
  display: flex;
}

.titleWrapper {
    position: relative;
    top: 10px; 
}

.tabs {
  display: flex;
  width: 80vw;
  height: 4vh;
  padding: 10px 0px 10px 15px;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
}

.tab {
  padding: 15px;
  cursor: pointer;
  font-size: 15px;
  background-color: #F4F4F4;
  border: 1px solid #ebebeb;
  margin: 2.5px;
}

.tab.active {
  background-color: #052C65; /*49566e*/
  color: white;
}

</style>